export default __webpack_public_path__ + "60b919b48ed24242f4967b103ab326db.png";